import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let CharacterSheetMenuButton = class CharacterSheetMenuButton extends Vue {
};
__decorate([
    Prop(String)
], CharacterSheetMenuButton.prototype, "text", void 0);
__decorate([
    Prop(String)
], CharacterSheetMenuButton.prototype, "icon", void 0);
__decorate([
    Prop(String)
], CharacterSheetMenuButton.prototype, "color", void 0);
__decorate([
    Prop(Object)
], CharacterSheetMenuButton.prototype, "on", void 0);
CharacterSheetMenuButton = __decorate([
    Component
], CharacterSheetMenuButton);
export default CharacterSheetMenuButton;
